export default {
  EBWS_PING: 'ping',
  EBWS_PONG: 'pong',
}
